export default __webpack_public_path__ + "static/media/logo.a2e408a4.svg";